import Inputmask from 'inputmask';
export default function (selector) {
    const specificSelector = selector ? selector : '[name="checkout_customer[main_telephone]"]';
    const phoneElem = document.querySelector(specificSelector);

    if (phoneElem) {
        const im = new Inputmask('+79999999999');
        im.mask(phoneElem);
    }
}
